import { Extension } from '@tiptap/core'

export interface StorageData {
  [key: string]: any
}

export const Storage = Extension.create({
  name: 'storage',

  addOptions() {
    return {
      storage: {},
    }
  },

  addStorage() {
    return this.options.storage
  },
})
